import type { Router } from "@/typeDefinitions/custom/Router";

const router: Router.LicensedRouterExportType = [
  {
    path: "/instance/incomingList",
    name: "IncomingInstanceList",
    component: () => import("./views/IncomingInstanceList.vue"),
    meta: {
      rights: ["instance.admin"],
    },
  },
  {
    path: "/instance/incoming/create",
    name: "CreateIncomingInstance",
    component: () => import("./views/CreateIncomingInstance.vue"),
    meta: {
      rights: ["instance.admin"],
    },
  },
  {
    path: "/instance/incoming/update/:id",
    name: "UpdateIncomingInstance",
    component: () => import("./views/UpdateIncomingInstance.vue"),
    props: (route) => {
      return {
        id: Number(route.params.id),
      };
    },
    meta: {
      rights: ["instance.admin"],
    },
  },
];

export default router;
